import React from "react";
import { Carousel } from "react-bootstrap";
import "./CarouselSection.css";

import slide1 from "../assets/slide1.jpg";
import slide2 from "../assets/slide2.jpg";
import slide3 from "../assets/slide3.jpg";
import slide4 from "../assets/slide4.jpg";

function CarouselSection() {
  const slides = [
    {
      image: slide1,
      title: "Transforming Spaces Through Light",
      subtitle: "Innovative Indoor & Outdoor Lighting",
    },
    {
      image: slide2,
      title: "Elegant Lighting Solutions",
      subtitle: "Creating Ambience with Premium Designs",
    },
    {
      image: slide3,
      title: "Commercial & Hospitality Lighting",
      subtitle: "Lighting Experiences Tailored For Every Project",
    },
    {
      image: slide4,
      title: "Premium Lighting Consultancy",
      subtitle: "Design • Innovation • Excellence",
    },
  ];

  return (
    <section className="hero-section">
      <Carousel
        fade
        controls
        indicators
        interval={4000}
        pause={false}
      >
        {slides.map((slide, index) => (
          <Carousel.Item key={index}>
            <div className="carousel-overlay"></div>

            <img
              className="d-block w-100 hero-image"
              src={slide.image}
              alt={slide.title}
            />

            <Carousel.Caption>
              <h1>{slide.title}</h1>
              <div className="hero-line"></div>
              <p>{slide.subtitle}</p>

              <a href="#contact">
                <button className="hero-btn">
                  Contact Us
                </button>
              </a>
            </Carousel.Caption>
          </Carousel.Item>
        ))}
      </Carousel>
    </section>
  );
}

export default CarouselSection;